import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { OssVatRateRepositoryBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@Wrapper(OssVatRateRepositoryBase)
export class OssVatRateRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
